module.exports = __webpack_public_path__ + "img/depression-animate.f0897035.svg";